import { Component, Input } from '@angular/core';

@Component({
  selector: 'usb-edit-search-modal',
  template: `
    <usb-popup
      [isLoading]="true"
      [popupClass]="'bg'"
      [iconUrl]="iconUrl"
    >
      <div class="mb-3">
        <img class="fa-spin" width="40" height="40" src="../../../../assets/icons/SPINNER.svg" alt="Spinner" />
      </div>
      <h2 class="cancel-loader_title">Editar Busqueda</h2>
      <h3 class="cancel-loader_subtitle mb-2">de {{ categoryLabel }}</h3>
      <p class="cancel-loader_text">Cargando Información <br /> Gracias por esperar</p>
    </usb-popup>
  `,
  styleUrls: ['./edit-search-modal.component.scss']
})

export class EditSearchModalComponent {
  @Input() category: 'alojamientos' | 'asistencias' | string = 'alojamientos';

  /**
   * URL de la imagen dinámica que muestra el usb-popup. Si viene null/undefined,
   * el popup muestra su imagen default (assets/img/image.png).
   * Cada consumidor (insurance, hotels, etc.) es responsable de calcular y
   * pasar la URL correspondiente a su categoría.
   */
  @Input() iconUrl: string | null = null;

  get categoryLabel(): string {
    switch (this.category) {
      case 'asistencias':
        return 'Asistencias';
      case 'alojamientos':
      default:
        return 'Alojamientos';
    }
  }
}